import { App } from '@capacitor/app'
import { defineNuxtPlugin } from 'nuxt/app'
import type { Plugin } from '~~/plugins/plugins'
import { navigateValidDeepLink } from '~/lib/url/deepLink'

export const deepLinkHandler: Plugin = (nuxtApp) => {
  const { $platform } = nuxtApp
  if (!$platform.isNative) return

  // Listen to URL when app is already open
  App.addListener('appUrlOpen', ({ url }) => {
    if (url.indexOf('https://') !== 0) return // Ignore non-https links
    navigateValidDeepLink(url)
  })
}

export default defineNuxtPlugin(deepLinkHandler)
